// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2566":"49a7254c","4332":"6c8082f0","4970":"97859f1e","5706":"f562260a","5924":"1d05483f","7175":"f9f78b90","7454":"85238e84","8766":"596e9602","9096":"72589ae3"}[chunkId] + ".chunk.css";
};